import React from "react";
import { Sheet, SheetContent } from "src/components/ui/sheet";
import PanelFileUpload from "./panel-file-upload";
import ManagePanelTable from "./manage-panel-table";
import { Panel } from "../../types/panel.types";
import BorderedInput from "src/components/form-new/bordered-input";
import { Lock } from "lucide-react";

interface PanelDescriptionsBarState {
  progress: number;
  timeRemainingLabel: string;
}

interface PanelDrawerProps {
  open: boolean;
  onOpenChange: (panelOrOpen?: Panel | boolean) => void;
  panel?: Panel;
  activePanel: Panel | null;
  onFileChange: (file: File | null) => void;
  onPanelChange: (field: string, value: any) => void;
  onColumnsChange: (id: string, field: string, value: any) => void;
  onUnlock?: (panelId: string) => void | Promise<void>;
  onLock?: (panelId: string) => void | Promise<void>;
  descriptionsBar?: PanelDescriptionsBarState | null;
  onGenerateDescriptions?: (rules: string[]) => void;
  isGeneratingDescriptions?: boolean;
}

const PanelDrawer: React.FC<PanelDrawerProps> = ({
  open,
  onOpenChange,
  activePanel,
  onFileChange,
  onPanelChange,
  onColumnsChange,
  onUnlock,
  onLock,
  descriptionsBar,
  onGenerateDescriptions,
  isGeneratingDescriptions,
}) => {
  if (!open) return null;

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <SheetContent
        side="right"
        className="!w-[75vw] sm:!w-[85vw] !max-w-none overflow-y-auto bg-white"
      >
        {!activePanel && (
          <PanelFileUpload
            onFileChange={onFileChange}
          />
        )}
        {activePanel && (
          <>
            <div className="flex items-center justify-between border-b border-gray-200 pb-2 mb-4">
              <BorderedInput
                className="w-[500px] text-2xl font-light"
                value={activePanel.name}
                onBlur={(e) => onPanelChange('name', e.target.value)}
                disabled={activePanel.locked}
              />
              {activePanel.locked && (
                <Lock className="w-4 h-4" />
              )}
            </div>
            {descriptionsBar && (
              <div className="mb-4 space-y-1.5">
                <div className="flex items-center justify-between text-[11px] text-muted-foreground">
                  <span>
                    Generating descriptions…
                  </span>
                  <span>
                    About
                    {' '}
                    {descriptionsBar.timeRemainingLabel}
                    {' '}
                    remaining
                  </span>
                </div>
                <div className="h-1 w-full max-w-md rounded-full bg-gray-200 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-blue-500 transition-[width] duration-150 ease-linear"
                    style={{ width: `${descriptionsBar.progress * 100}%` }}
                  />
                </div>
              </div>
            )}
            <ManagePanelTable
              panel={activePanel}
              onPanelChange={onPanelChange}
              onColumnsChange={onColumnsChange}
              onUnlock={onUnlock}
              onLock={onLock}
              onGenerateDescriptions={onGenerateDescriptions}
              isGeneratingDescriptions={isGeneratingDescriptions}
            />
          </>
        )}

      </SheetContent>
    </Sheet>
  );
};

export default PanelDrawer;
